const MAX_RECENT = 10;

const getKey = (userId) => `recentCandidates_${userId}`;

export const getRecentCandidates = (userId) => {
  try {
    const stored = localStorage.getItem(getKey(userId));
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const trackCandidate = (userId, candidate) => {
  if (!userId || !candidate?.id) return;

  const recent = getRecentCandidates(userId);
  // Remove if already in list
  const filtered = recent.filter(c => c.id !== candidate.id);
  // Add to front
  filtered.unshift({
    id: candidate.id,
    name: candidate.name,
    countryCode: candidate.countryCode || '+91',
    phone: candidate.phone,
    position: candidate.position,
    status: candidate.status,
    touchedAt: new Date().toISOString()
  });
  // Keep only last N
  const trimmed = filtered.slice(0, MAX_RECENT);
  localStorage.setItem(getKey(userId), JSON.stringify(trimmed));
};
